import React from 'react';
import RadioGroup from 'apollo-react/components/RadioGroup';
import Radio from 'apollo-react/components/Radio';

const RadioGroupInput = ({
  field,
  meta,
  label,
  options,
  onChange,
  value,
  required,
}) => {
  return (
    <RadioGroup
      {...field}
      label={label}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error ? meta.error : ''}
      onChange={(e) => onChange(e.target.value)}
      value={value}
      required={required}
    >
      {options.map((option) => (
        <Radio key={option.value} value={option.value} label={option.label} />
      ))}
    </RadioGroup>
  );
};

export default RadioGroupInput;
